/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';
import { RepdashWindowRef } from '@experience/repdash/interfaces/repdash.interface';

/**
 * Service that holds a reference of window
 *
 * And have window/document specific functions
 *
 *
 *
 * @export
 * @class WindowRefService
 */
/* tslint:disable:no-any*/
@Injectable(
  { providedIn: 'root' }
)
export class WindowRefService {
  /**
   * Reference to window.
   *
   * @private
   * @type {Window}
   * @memberof WindowRefService
   */
  private readonly windowRef: RepdashWindowRef;

  constructor() {
    this.windowRef = window;
  }

  /**
   * Returns window,
   *
   * @returns {Window}
   * @memberof WindowRefService
   */
  public nativeWindow(): RepdashWindowRef {
    return this.windowRef;
  }
}
